module.exports = __webpack_public_path__ + "sprstatic/img/login.b31bc18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login.png
// module id = 6QGk
// module chunks = 2